export default __webpack_public_path__ + "d00fccca73df179b90f3543ffdd978a0.png";